export default __webpack_public_path__ + "static/media/portal.422b27ca.svg";